import React from "react";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';

function PopUpScreen({ header, onHide, children, style, ...rest }) {
  return (
    <Dialog
      open={true}
      onClose={onHide}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          ...style
        }
      }}
      {...rest}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: '18px',
          color: '#0000a0',
          borderBottom: '1px solid #e0e0e0',
          padding: '20px 24px 16px 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {header}
        <IconButton
          onClick={onHide}
          sx={{
            color: '#666',
            '&:hover': {
              backgroundColor: '#f0f0f0'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: '24px' }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export default PopUpScreen;
